import { Currency } from '@src/@types/currency';
import { pilotKZPageRoute } from '@src/server/routes/constants';

import currencies from '../constants/currency';

export const getSymbolByCode = (code: Currency = Currency.RUB): string => currencies[code];

export const getCurrency = (path: string) => (path.startsWith(pilotKZPageRoute) ? Currency.KZT : Currency.RUB);
